import PropTypes from 'prop-types';
import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import Header from './components/Header';
import Sidebar from './components/Sidebar';

import i18n from '~/common/helpers/i18n';
import TopBar from '~/components/TopBar';

const Container = styled.div`
  height: calc(100vh - 32px);
`;

const Content = styled.div`
  height: 100%;
  display: flex;
`;

const Body = styled.div`
  width: 100%;
  overflow: hidden;
`;

const WrapperSwitch = styled.div`
  padding-left: 24px;
  padding-right: 24px;
  width: 100%;
  box-sizing: border-box;
  height: calc(100% - 112px);
  overflow: auto;
`;

const Settings = ({
  containPaths,
  onPressBack,
  realm,
  realmData,
  license,
  hasCustomerIdentityProvider
}) => (
  <Container>
    <TopBar
      onBack={onPressBack}
      linkText={i18n.t('scenes.beta.actions.back_to_pipelines')}
    />
    <Content>
      <div>
        <Sidebar
          containPaths={containPaths}
          realm={realm}
          realmData={realmData}
          license={license}
          hasCustomerIdentityProvider={hasCustomerIdentityProvider}
        />
      </div>
      <Body>
        <Header license={license} />
        <WrapperSwitch>
          <Outlet />
        </WrapperSwitch>
      </Body>
    </Content>
  </Container>
);

Settings.defaultProps = {
  containPaths: () => {},
  onPressBack: () => {}
};

Settings.propTypes = {
  containPaths: PropTypes.func,
  onPressBack: PropTypes.func,
  realm: PropTypes.string.isRequired,
  realmData: PropTypes.objectOf({}).isRequired,
  license: PropTypes.objectOf({}).isRequired,
  hasCustomerIdentityProvider: PropTypes.string.isRequired
};

export default Settings;
